import React from 'react';
import ErrorBoundary from 'error/components/ErrorBoundary';
import { ErrorBoundaryVariant } from 'types';
import { getDisplayName } from 'helpers/getDisplayName';
import { ErrorBoundaryContext } from 'contexts/ErrorBoundaryContext/ErrorBoundaryContext';

// Use at the end of the component's file or in the index.ts
// Wrapping a components with ErrorBoundary allow to log a fatal if an unhandle error happens,
// and render the fallback UI. Allowing the app to continue to work.
// We should use on all pages, when a components is use in many places or when it handle complex logic.
// This do not replace proper error handling, your components and test suite should cover all expected errors scenarios.
// For more info consult error/README.md
export function withErrorBoundary<T>(
    // eslint-disable-next-line @typescript-eslint/naming-convention
    WrappedComponent: React.FC<T>,
    variant: ErrorBoundaryVariant,
) {
    const displayName = getDisplayName<T>(WrappedComponent, 'WrappedComponent');

    return class extends React.Component<T> {
        render() {
            return (
                <ErrorBoundaryContext.Consumer>
                    {({ setError }) => (
                        <ErrorBoundary
                            variant={variant}
                            displayName={displayName}
                            setError={setError}
                        >
                            <WrappedComponent {...this.props} />
                        </ErrorBoundary>
                    )}
                </ErrorBoundaryContext.Consumer>
            );
        }
    };
}
